import { render, staticRenderFns } from "./add-estate-btn.vue?vue&type=template&id=78f40a36&"
import script from "./add-estate-btn.vue?vue&type=script&lang=js&"
export * from "./add-estate-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports